import { NotificationActionType } from "@core/data/type/notification-action.type";

export class NotificationAction {
  constructor(
    public type: NotificationActionType,
    public metadata: Record<string, any>
  ) {
  }
}

export const PATH_KEY = "path";
